import { render, staticRenderFns } from "./Matured.vue?vue&type=template&id=32d8e85e"
import script from "./Matured.vue?vue&type=script&lang=js"
export * from "./Matured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports